import { systolicOf } from '../../domain';
/**
 * A mini-serie que vai ao lado de um numero - o `MiniChart` do painel antigo.
 *
 * Fica aqui, fora de qualquer presenter, porque DUAS telas a desenham: o painel da
 * empresa e o painel do paciente. As duas agrupam por dia quando o periodo e maior
 * que um dia, porque num tracinho de 96px o detalhe horario nao tem para onde
 * caber.
 */
export function buildSpark(points, metric, window) {
    if (!points || points.length === 0) {
        return [];
    }
    const delta = metric === 'TEMPERATURA';
    const pressure = metric === 'PRESSAO';
    // A pressao entra pela SISTOLICA. O painel antigo plota o inteiro codificado
    // (`121074`), em que os tres ultimos digitos sao a diastolica - a linha sobe e
    // desce por causa dela, e nao pelo que o cartao esta dizendo. Divergencia de
    // proposito: nao ha leitura correta do numero cru.
    const rounded = (value) => pressure
        ? systolicOf(value)
        : Math.round((delta ? value - (window.temperatureReference ?? 36) : value) * 100) / 100;
    if (window.singleDay) {
        return points.map((point) => rounded(point.averageValue ?? 0));
    }
    const byDay = new Map();
    for (const point of points) {
        const day = (point.date ?? '').slice(0, 10);
        if (!day) {
            continue;
        }
        const bucket = byDay.get(day) ?? { sum: 0, count: 0 };
        bucket.sum += point.averageValue ?? 0;
        bucket.count += 1;
        byDay.set(day, bucket);
    }
    const daily = [...byDay.keys()].sort().map((day) => {
        const bucket = byDay.get(day);
        return bucket.sum / bucket.count;
    });
    return condense(daily, window.maxPoints).map(rounded);
}
/**
 * Encolhe a serie ate caber, agrupando dias VIZINHOS.
 *
 * Nao e cortar a cauda. O painel antigo cortava - ficava com os ultimos 30 dias -
 * porque so tinha tres janelas e a maior era um mes, entao cortar nunca tirava
 * nada. Com periodo livre isso passaria a mentir: um cartao dizendo a media do
 * trimestre teria ao lado uma linha do ultimo mes.
 *
 * Os baldes tem tamanho quase igual - a divisao inteira sobra alguns dias, e eles
 * sao distribuidos um a um pelos primeiros baldes, em vez de todos no ultimo.
 */
function condense(values, maxPoints) {
    if (values.length <= maxPoints) {
        return values;
    }
    const size = Math.floor(values.length / maxPoints);
    let leftover = values.length % maxPoints;
    const condensed = [];
    let start = 0;
    for (let bucket = 0; bucket < maxPoints; bucket++) {
        const length = size + (leftover > 0 ? 1 : 0);
        if (leftover > 0) {
            leftover--;
        }
        const slice = values.slice(start, start + length);
        condensed.push(slice.reduce((sum, value) => sum + value, 0) / slice.length);
        start += length;
    }
    return condensed;
}
//# sourceMappingURL=spark.js.map